import {
  getVisibleOoCaseSidebarItemIds,
  mapOoCaseSidebarItemToUrlSection,
  normalizeOoSectionParam,
} from 'components/CaseSidebar';
import type { OoCaseSidebarContext } from 'components/CaseSidebar/buildOoCaseSidebar';
import { CaseSidebarItemId } from 'components/CaseSidebar/types';
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function useOoSectionNavigation(context: OoCaseSidebarContext) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const formSectionParam = searchParams.get('section');
  const allowedSectionIds = useMemo(() => getVisibleOoCaseSidebarItemIds(context), [context]);

  const updateSectionInUrl = useCallback(
    (itemId: CaseSidebarItemId) => {
      navigate({ search: `?section=${mapOoCaseSidebarItemToUrlSection(itemId)}` });
    },
    [navigate],
  );

  useEffect(() => {
    const normalizedSection = normalizeOoSectionParam(formSectionParam, context);

    if (!normalizedSection || !allowedSectionIds.includes(normalizedSection)) {
      navigate({ search: `?section=${allowedSectionIds[0]}` }, { replace: true });
      return;
    }

    if (formSectionParam !== mapOoCaseSidebarItemToUrlSection(normalizedSection)) {
      navigate({ search: `?section=${mapOoCaseSidebarItemToUrlSection(normalizedSection)}` }, { replace: true });
    }
  }, [allowedSectionIds, context, formSectionParam, navigate]);

  return {
    formSectionParam,
    updateSectionInUrl,
  };
}
